import * as Accordion from '@radix-ui/react-accordion';

/** "How to read this" accordion shown under every chart (§10.4, Appendix B). */
export function HowToRead({ text }: { text: string }) {
  return (
    <Accordion.Root type="single" collapsible className="mt-1 no-print">
      <Accordion.Item value="help">
        <Accordion.Header>
          <Accordion.Trigger className="text-xs font-medium text-sky-700 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 dark:text-sky-400">
            How to read this
          </Accordion.Trigger>
        </Accordion.Header>
        <Accordion.Content className="pt-1 text-xs leading-relaxed text-slate-600 dark:text-slate-400">
          {text}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
}
